import React from 'react'

//Mainly spinner
interface ICIrcleSpinner {
	className?: string
}
export function CircleSpinner({ className }: ICIrcleSpinner) {
	return (
		<div id="circle-spinner" className={className ? className : ''}></div>
	)
}

//Loading spinner with three dots
export function LoadingSpinner() {
	return <div id="loading-spinner"></div>
}
